<div >
  <ion-header>
    <ion-toolbar color="light">
      <ion-title>Fuel</ion-title>
    </ion-toolbar>
  </ion-header>
  <div class="fuel-wrapper">
    <ion-item>
      <ion-label position="floating">Add Fuel</ion-label>
      <ion-input [(ngModel)]="fuel" aria-label="Fuel"></ion-input>
    </ion-item>
    <div class="fuel-buttons">
      <ion-button size="small" (click)="onClickCancel()">Cancel</ion-button>
      <ion-button size="small" (click)="onClickSave()">Save</ion-button>
    </div>
  </div>
</div>
